import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { ICourse, IGetCourse } from '../../../models/courses.model'
import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/program/course/Editor';
import useAxios from '../../../hooks/useAxios';
import { getCourse, updateCourse } from '../../../api/courses.api';
import ErrorResponse from '../../../components/ErrorResponse';
import useNotification from '../../../hooks/useNotification';

interface IMatch {
  id: string;
};

const ProgramCourseEdit: FC = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetCourse>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();
  
  useEffect(() => {
    execute(getCourse(id));
  }, []);

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.edit'));
      history.push(`/program/course${location.search}`);
    }
  }, [submitRes]);

  const submit = async (req: ICourse) => {
    submitExecute(updateCourse(id, req));
  };

  return (
    <div className="content scrollbar">
      {(isLoading || submitIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('program.course.title3')}
      />
      <Editor
        course={res?.data}
        submit={submit}
      />
      <Footer />
    </div>
  )
}

export default ProgramCourseEdit;
